<a
  class="ui-whatsapp-fab"
  [href]="href()"
  target="_blank"
  rel="noopener noreferrer"
  [attr.aria-label]="ariaLabel()"
>
  <img
    class="ui-whatsapp-fab__image"
    [src]="imageSrc()"
    [alt]="imageAlt()"
    width="56"
    height="56"
    loading="lazy"
  />
</a>
